export default import.meta.ROLLDOWN_FILE_URL_PjElCpJ50M8sBJLd$C91mw